'use client'
import Footer from '@/components/Footer';
import usePhoneNumber from '@/hooks/usePhoneNumber';
import 'swiper/css';
import 'swiper/css/pagination';
import MainMenu from '@/components/MainMenu';

export default function Page() {
  const { phoneNumber, isCookieLoading } = usePhoneNumber();

  return (
    <main className="flex min-h-screen flex-col items-center justify-between overflow-hidden">
      <MainMenu isLoading={isCookieLoading} phoneNumber={phoneNumber} />
      <section className="text-start pt-10 pb-0 md:py-24 w-screen justify-start bg-gradient-to-b from-gradient-start to-white dark:from-purple-700 dark:to-dark">
        <div className="container my-20">
          <div className="space-y-10">
            <div className="text-4xl md:text-6xl font-semibold">
              Хамтран ажиллах
            </div>
            <div className="text-lg space-y-4">
              <p className="mb-2">
                Грейт Айкт ХХК нь Монголын хүн амын тодорхой сегмент бүлэгт чиглэсэн сэтгэц-хэмжил зүйн тест боловсруулалт, нутагшуулалт болон судалгаа шинжилгээ хийх чиглэлээр үйл ажиллагаа явуулдаг. Манай үндсэн бүтээгдэхүүн болох сэтгэл зүйн асуулга нь сурагчдын мэргэжил сонголтыг оновчтой болгох, карьер зөвлөгөөг мэргэжлийн түвшинд хүргэж ажиллахыг зорьдог бөгөөд холбогдох боловсролын байгууллага, инститүц, төрийн бус байгууллагуудтай хамтран ажиллах үүд хаалга нээлттэй.
              </p>
              <p className="mb-2">
                Хэрэв та сурагчдад өөрийгөө таньж, потенциалаа нээн илрүүлэх, ажил мэргэжлээ сонгоход нь туслах хүсэлтэй бол та бидэнтэй <a href="mailto:sales@mycareer.mn" className="text-blue-600 underline">sales@mycareer.mn</a> мэйл хаягаар эсвэл <a href="tel:+97686186498" className="text-blue-600 underline">+976-86186498</a> утсаар холбогдох боломжтой.
              </p>
              <p className="mb-2">
                Та бидний хамтын ажиллагаа ажил мэргэжлийн утга учиртай аялалд сурагчдад уриалан, урам зориг өгч, амьдралд нь урт хугацааны эерэг өөрчлөлт авчирна гэдэгт итгэлтэй байна.
              </p>
            </div>

            <div className="text-lg mt-8 space-y-4">
              <div className="flex items-center">
                <span className="font-semibold">Утас:</span>
                <a href="tel:+97686186498" className="ml-2 text-blue-600 underline">+976-86186498</a>
              </div>
              {/* <div className="flex items-center">
                <span className="font-semibold">Хаяг:</span>
                <span className="ml-2">Улаанбаатар, Сүхбаатар дүүрэг, 1-р хороо, SAV плаза, 309 тоот</span>
              </div> */}
              <div className="flex items-center">
                <span className="font-semibold">Имэйл:</span>
                <a href="mailto:sales@mycareer.mn" className="ml-2 text-blue-600 underline">sales@mycareer.mn</a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </main>
  )
}
